import React from 'react';
import TemplateEventi from '../../components/template-eventi-pubblicazioni';
import { getProp, getPropRel, getPropAsset, getPropMarked } from '../utils';

const EventiPreview = (props) => {
  const title = getProp(props, 'title');
  const titleEvents = getProp(props, 'titleEvents');
  const titlePublications = getProp(props, 'titlePublications');
  const events = getPropRel(props, 'events', 'event');
  const publications = getPropRel(props, 'publications', 'publication');
  const titlePage = getProp(props, 'titlePage');
  const textPage = getPropMarked(props, 'textPage');
  const imagePage = getPropAsset(props, 'imagePage');

  return (
    <TemplateEventi
      {...{
        title,
        titleEvents,
        titlePublications,
        events,
        publications,
        titlePage,
        textPage,
        imagePage
      }}
    />
  );
};

export default EventiPreview;
